// extracted by mini-css-extract-plugin
export default {"faqs-wrapper":"Faqs-module__faqs-wrapper--KhpPE","accordion-head":"Faqs-module__accordion-head--ESJhy"};